if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.preAddOnButton = this.querySelector('#preAddOn')
      if(this.preAddOnButton){
        this.preAddOnButton.addEventListener('click' , this.onCompletePackage.bind(this))
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getAddOnProducts(){
      var activeAddOn = Array.from(document.querySelectorAll('input[name="add-on"]:checked'));
      if ( activeAddOn.length > 0 ){
        var selectedAddOn = activeAddOn.map(addon => ( {id: addon.dataset.variant, quantity: 1 } ) );
        return selectedAddOn    
      }
      else{
        return false;  
      }  
    }

    clearAddOnProducts(){
      var allAddOn = Array.from(document.querySelectorAll('input[name="add-on"]:checked'));
      if ( allAddOn.length > 0 ){
        allAddOn.forEach(addon =>{
            console.log(addon)
            addon.checked=false;
          })
      }

    }

    onCompletePackage() {
      this.preAddOnButton.classList.add("hide");
      var originalAtc = this.querySelector('button[type=submit]')
      var addOnWrapper = this.querySelector('.add-on-wrapper')
      originalAtc.classList.remove("hide")
      addOnWrapper.classList.remove("hide")
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      var parentObj = this;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {

              if(this.getAddOnProducts()){

                var formData = {
                    items: this.getAddOnProducts(),
                  }

                  fetch('/cart/add.js',  {
                    method: 'POST',
                    body: JSON.stringify(formData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
        
                      }
                  }).then(response => {
                      return response
                    })
                  .then(function(data) {
                    console.log(data)
                    parentObj.clearAddOnProducts()
                    window.location = window.routes.cart_url;
                    return;
                  })               
              } 
              else{
                  window.location = window.routes.cart_url;
                  return;
              }
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        
        })
       
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


//Custom Functions

window.theme = window.theme || {};

theme.AddOn = (function() {
  function AddOn(container) {
    this.init(container);
    console.log(container)
  };

  AddOn.prototype = Object.assign({}, AddOn.prototype, {
    init: function(container) {     
        this.container = container;
        this.allAddOn = this.selectAll('input[name="add-on"]');
        this.allTabs = this.selectAll('.add-on-tab')
        this.modal = document.querySelector("#myModal");
        this.addEventListeners();
    }, 

  selectAll: function(selector){
    return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

  addEventListeners: function(){
      this.allAddOn.forEach(addOn=>{
          addOn.addEventListener('change', this.handleChange.bind(this));      
        });

      this.allTabs.forEach(tab =>{
        console.log(tab)
        tab.addEventListener('click' , this.selectTab.bind(this))
      });

      var quickView = document.querySelectorAll('.quickViewAddOn');
      quickView.forEach(qv => {
        qv.addEventListener('click' , this.displayQuickView.bind(this))
      })

      // var magnifier = document.querySelector('.magnifier')
      // magnifier.addEventListener('click', this.displayQuickViewMagnifier.bind(this))

      var closeQuickView = document.querySelectorAll(".close");
      closeQuickView.forEach( close => {
        close.addEventListener('click', this.closeQuickView.bind(this))
      })  

    },    



    displayQuickView: function(e){
      console.log(e)
      var modalImage = document.querySelector('#qvImage')
      var modalTitle = document.querySelector('#qvTitle')
      var modalPrice = document.querySelector('#qvPrice')
      var modalDescription = document.querySelector('#qvDescription')

      if(e.target.nodeName == "circle"){
        console.log("circle")
        var metafield = addOnMeta[e.target.parentElement.dataset.id]
        var updatedDesc = metafield.add_on_short_Description.replaceAll('\r\n', '<br>')
        modalImage.src = metafield.add_on_image
        modalTitle.innerHTML = metafield.add_on_description_title
        modalPrice.innerHTML =  `${Shopify.formatMoney(metafield.add_on_price)}`
        modalDescription.innerHTML = updatedDesc;
      }
     else if(e.target.classList.contains('magnifier')){
        console.log("magnifier")
        var metafield = addOnMeta[e.target.parentElement.dataset.id]
        var updatedDesc = metafield.add_on_short_Description.replaceAll('\r\n', '<br>')
        modalImage.src = metafield.add_on_image
        modalTitle.innerHTML = metafield.add_on_description_title
        modalPrice.innerHTML =  `${Shopify.formatMoney(metafield.add_on_price)}`
        modalDescription.innerHTML = updatedDesc;
      }
      else{
        var metafield = addOnMeta[e.target.dataset.id]
        var updatedDesc = metafield.add_on_short_Description.replaceAll('\r\n', '<br>')
        modalImage.src = metafield.add_on_image
        modalTitle.innerHTML = metafield.add_on_description_title
        modalPrice.innerHTML =  `${Shopify.formatMoney(metafield.add_on_price)}`
        modalDescription.innerHTML = updatedDesc;
      }

  
  
  
      this.modal.style.display = "block";
    },
  
    closeQuickView: function(){
      this.modal.style.display = "none";
    },  

  selectTab: function(e){

    this.allTabs.forEach(tab => {
      tab.classList.remove('active-tab');
    })
    console.log(e.target.classList)
    console.log(e)
    if(e.target.classList.contains('icon')){
      console.log("icon")
      e.target.parentElement.parentElement.parentElement.classList.add('active-tab')

    }
    else if(e.target.classList.contains('add-on-tab')){
      e.target.classList.add('active-tab')
    }
    else{
    e.target.parentElement.classList.add('active-tab')
    }
  },

  updateSelectedTitle: function(title , addTitle){
    var elSelectedAddOn = document.querySelector('#selectedAddOn')
    var listAddOn = elSelectedAddOn.dataset.selected
    var newListAddOn;
    if(addTitle){
      if(listAddOn.length === 0){
        newListAddOn = title
      }
      else{

        newListAddOn = title + ',' + listAddOn
        console.log(newListAddOn)
      }
      elSelectedAddOn.innerHTML = newListAddOn.split(',').join(' - ');
    }
    else{
      listAddOn = listAddOn.toString().split(',')
      console.log(listAddOn)
      newListAddOn = listAddOn.filter( t => t != title)
      elSelectedAddOn.innerHTML = newListAddOn.toString().split(',').join(' - ');
    }

    elSelectedAddOn.dataset.selected = newListAddOn
    if(elSelectedAddOn.innerHTML == ""){
      elSelectedAddOn.innerHTML = "Click to select"
    }

  },

  handleChange: function(e){
    console.log(e.target.checked + " " + e.target.dataset.tab)
    if(e.target.checked){
       var selectedLabel = document.querySelector('label[for=' + e.target.dataset.tab + ']')
       selectedLabel.classList.add('selected__add__on')
       selectedLabel.parentElement.classList.add('active-tab')       
       this.updateSelectedTitle(e.target.dataset.title , true)

    }
    else{
      var selectedLabel = document.querySelector('label[for=' + e.target.dataset.tab + ']')
       selectedLabel.classList.remove('selected__add__on')
       this.updateSelectedTitle(e.target.dataset.title , false)

    }
    this.updateAddOnPrice()
    
    },

  getAddOnPrice: function(){
      var activeAddOn = Array.from(document.querySelectorAll('input[name="add-on"]:checked'))
      let totalAddOnPrice = 0;
      activeAddOn.forEach(addOn => {
        totalAddOnPrice += parseInt(addOn.dataset.price);
        
      });
      return totalAddOnPrice;
  
    },

  updateAddOnPrice: function(){
      var elSubtotal = document.getElementById('variantPriceATC')
      if(elSubtotal){
        var subtotalPrice = elSubtotal.dataset.price;
        var updatedSubtotalPrice = parseInt(subtotalPrice) + this.getAddOnPrice()
        console.log(updatedSubtotalPrice)
        elSubtotal.innerHTML = `${Shopify.formatMoney(updatedSubtotalPrice, "€{{amount}}")} | `;
      }

    }  
  });

  return AddOn;
  })(); 
  new theme.AddOn(document.querySelector('.add-on-wrapper'));
 